import FJUtil from '../../util/FJUtil';
import FJMessageStore from '../../store/FJMessageStore';
import FJLocalStore from '../../store/FJLocalStore';
import {
    setSliceDownloadEditImageLoading,
    setSliceImageEnhancerDataAction,
    setSliceScratchRepairMaskUrl,
    setSliceSwitchPhotoColorizeAction,
    setSliceSwitchScratchOrFold,
    setSliceUploadImageInfoAction,
    setSliceUseNumFunctionData,
    setSliceSwitchOldPhotoRestorationAction,
} from '../slices/FJSliceImageManipulation';
import FJActionCommon from './FJActionCommon';
import FJConstant from '../../constants/FJConstant';
import { setSliceCreationListAction, setSliceTaskStatusAction } from '../slices/FJSliceCommon';
import FJActionModal from './FJActionModal';
import FJImageStore from '../../store/FJImageStore';
import FJNetworkStore from '../../store/FJNetworkStore';
import FJCompressedImageStore from '../../store/FJCompressedImageStore';
import FJActionBrushEditCommon from './FJActionBrushEditCommon';
import {
    MOUSE_EVENT_TYPE,
    FJViewCanvasSingleton,
} from '../../components/FJMainPreview/FJCreationEditPanel/js/FJViewCanvas';
import {
    setSliceDisableCompare,
    setSliceDisableReset,
    setSliceIsMouseMove,
    setSliceIsSlideCompare,
} from '../slices/FJSliceBrushEditCommon';
import FJAppConstant from '../../constants/FJAppConstant';
import FJLoadLocalforageStore from '../../store/FJLoadLocalforageStore';
import FJImageManipulationStore from '../../store/FJImageManipulationStore';
import { setSliceLoadingModalData } from '../slices/FJSliceModals';
import { MAX_COMPRESS_IMAGE_SIZE } from '../../config/dataConfig/FJGenerateData.js';
import FJCpmpressedImageStore from '../../store/FJCompressedImageStore.js';

let f_currentTaskId = null;
let f_eventId = null;
const _checkIsCurrentTask = id => {
    return id === f_currentTaskId;
};
const _imageManipulation = async (data, dispatch) => {
    const idInfo = await FJNetworkStore.imageProcessing(data);
    const { code, data: dataInfo } = idInfo;
    if (code === 401) {
        dispatch(FJActionModal.showUpgradeModalAction());
        return;
    } else if (code === 214) {
        FJUtil.anonymousSignUp()
            .then(() => {
                dispatch(FJActionCommon.initProjectInfoAction(true));
            })
            .catch(e => console.log(e));
        return;
    }
    const eventId = dataInfo?.event_id;
    if (!eventId) {
        throw new Error('create task error');
    }
    return eventId;
};

const FJActionImageManipulation = {
    resetAction: function () {
        return async (dispatch, getState) => {
            const appType = getState().common.appType;
            dispatch(setSliceUploadImageInfoAction({}));
            dispatch(FJActionBrushEditCommon.setEditImageAction(null));
            dispatch(FJActionBrushEditCommon.setOriginImageAction(null));
            dispatch(setSliceIsSlideCompare(false));
            // dispatch(this.setSliceSwitchScratchOrFoldAction(false));
            // dispatch(this.resetUseNumFunctionDataAction());
            if (appType === FJAppConstant.PHOTO_RESTORATION) {
                dispatch(setSliceSwitchOldPhotoRestorationAction(true));
                dispatch(setSliceSwitchPhotoColorizeAction(false));
            } else if (appType === FJAppConstant.PHOTO_COLORIZE) {
                dispatch(setSliceSwitchOldPhotoRestorationAction(false));
                dispatch(setSliceSwitchPhotoColorizeAction(true));
            }

            // dispatch(
            //     setSliceImageEnhancerDataAction({
            //         switch: false,
            //         imageType: FJConstant.FACE,
            //         upscale: 2,
            //     }),
            // );
        };
    },
    uploadImageAction: function (file) {
        return async dispatch => {
            const format = file.type;
            let resolution = '';
            let eventType = 'photo restoration & colorizer upload fail';
            const isImage = FJUtil.isImage(file);

            if (!isImage) {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
            } else {
                const data = await FJCompressedImageStore.compressImageByFile(file);
                if (data) {
                    resolution = data.width + ' * ' + data.height;
                    dispatch(setSliceUploadImageInfoAction(data));
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                    dispatch(FJActionBrushEditCommon.enterOrEndSlideCompareAction(false, false));
                    dispatch(FJActionBrushEditCommon.setEditImageAction(data));
                    dispatch(FJActionBrushEditCommon.setOriginImageAction(data));
                    dispatch(setSliceCreationListAction([]));
                    dispatch(this.resetSwitchAction());
                    dispatch(this.resetUseNumFunctionDataAction());
                    eventType = 'photo restoration & colorizer upload success';
                } else {
                    FJMessageStore.addMessage(
                        FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                        'error',
                    );
                }
            }
            FJUtil.eaLog(eventType, { format, resolution });
        };
    },
    uploadImageUrlAction: function (url, options = {}) {
        return async dispatch => {
            const { size, name, id } = options;
            let data;
            if (size.width > MAX_COMPRESS_IMAGE_SIZE || size.height > MAX_COMPRESS_IMAGE_SIZE) {
                data = await FJCpmpressedImageStore.compressImageByUrl(url, { name: name });
            } else {
                data = { name: name, src: url, width: size.width, height: size.height, id: id };
            }
            let resolution = '';
            if (data) {
                resolution = data.width + ' * ' + data.height;
                dispatch(setSliceUploadImageInfoAction(data));
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                dispatch(FJActionBrushEditCommon.enterOrEndSlideCompareAction(false, false));
                dispatch(FJActionBrushEditCommon.setEditImageAction(data));
                dispatch(FJActionBrushEditCommon.setOriginImageAction(data));
                dispatch(setSliceCreationListAction([]));
                dispatch(this.resetSwitchAction());
                dispatch(this.resetUseNumFunctionDataAction());
                FJUtil.eaLog('photo restoration & colorizer upload success', { resolution });
            } else {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
                FJUtil.eaLog('photo restoration & colorizer upload fail', {});
            }
        };
    },
    generateAction: function () {
        return async (dispatch, getState) => {
            const {
                switchOldPhotoRestoration,
                switchPhotoColorize,
                imageEnhancerData,
                uploadImageInfo,
                switchScratchOrFold,
            } = getState().imageManipulation;
            const options = {
                repair: switchOldPhotoRestoration,
                colorize: switchPhotoColorize,
                enhancerData: imageEnhancerData,
                imageInfo: uploadImageInfo,
                scratchOrFold: switchScratchOrFold,
            };

            dispatch(FJActionImageManipulation._imageManipulationAction(options));
        };
    },
    reGenerateAction: function () {
        return async (dispatch, getState) => {
            const { creationList } = getState().common;
            if (creationList.length === 0) return;
            const item = creationList[0];
            const data = item.generateInfo;
            dispatch(FJActionImageManipulation._imageManipulationAction(data));
        };
    },
    _imageManipulationAction: function (options) {
        return async (dispatch, getState) => {
            const { repair, colorize, enhancerData, imageInfo, scratchOrFold } = options;

            let { creditNumber, freeNumCreation } = getState().common;
            const factor = enhancerData?.upscale;

            let buryData = {};
            const __eaLog = () => {
                let use = '';
                repair && (use += 'old photo restoration');
                colorize && (use += ', photo colorizer');
                enhancerData?.switch && (use += ', image upscaler');
                scratchOrFold && (use += ', remove scratches/creases');
                buryData = {
                    use,
                    'upscaler size': factor + 'X',
                };
                FJUtil.eaLog('photo restoration & colorizer generate click', buryData);
            };

            __eaLog();
            const hasFreeCreation = freeNumCreation > 0;
            const useCredit = (repair + colorize + enhancerData?.switch + scratchOrFold) * 2;
            const currentTaskId = new Date().getTime();
            let _startTime = new Date().getTime();

            f_currentTaskId = currentTaskId;
            f_eventId = null;

            const __errorAndClear = () => {
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                dispatch(setSliceCreationListAction([]));
            };
            const __errorAndReLoad = () => {
                const creationList = getState().common.creationList;
                const reLoadList = creationList.map(i => ({
                    ...i,
                    isLoading: false,
                    isReload: true,
                }));
                dispatch(setSliceCreationListAction(reLoadList));
                dispatch(setSliceTaskStatusAction(FJConstant.ERROR));
            };

            //1.判断是否上传图片
            const editImageUrl = FJViewCanvasSingleton.getEditImageUrl();
            if (!editImageUrl) {
                FJMessageStore.addMessage(FJLocalStore._('please-upload-an-image-first'), 'error');
                return;
            }
            //2.判断是否开启功能
            if (!useCredit) {
                return FJMessageStore.addMessage(FJLocalStore._('please-activate-at-least-one-option'), 'error');
            }
            //开始状态修改
            const placeHolderList = FJUtil.createPlaceHolderList({
                count: 1,
                uploadImageInfo: imageInfo,
                generateInfo: {
                    repair,
                    colorize,
                    enhancerData,
                    imageInfo,
                    scratchOrFold,
                },
            });
            dispatch(setSliceCreationListAction(placeHolderList));
            dispatch(setSliceTaskStatusAction(FJConstant.START));

            dispatch(FJActionBrushEditCommon.enterOrEndSlideCompareAction(false, false));
            dispatch(FJActionBrushEditCommon.fitZoomAndPositionAction());
            //3.判断登陆

            const userSpaceType = await FJUtil.checkUserSpace({
                errorCallback: () => {
                    FJMessageStore.addMessage(
                        FJLocalStore._('failed-to-generate-the-image-please-try-it-again'),
                        'error',
                    );
                },
            });
            if (userSpaceType > 0) {
                dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                __errorAndClear();
                return;
            }

            if (!_checkIsCurrentTask(currentTaskId)) return;
            //4.额度判断
            if (creditNumber < useCredit && !hasFreeCreation) {
                dispatch(FJActionModal.showUpgradeModalAction());
                __errorAndClear();
                return;
            }
            const isFree = creditNumber < useCredit && hasFreeCreation;
            try {
                //5.上传图片到s3
                const s3Url = await FJImageManipulationStore.checkEditImageHasUploadS3(editImageUrl);
                const imageUrl = s3Url ? s3Url : await FJImageStore.upLoadFileToS3ByUrl(editImageUrl);
                const originImageUrl = await FJImageStore.upLoadFileToS3ByUrl(imageInfo.src);

                if (!_checkIsCurrentTask(currentTaskId)) return;
                if (!imageUrl || !originImageUrl) {
                    __errorAndClear();
                    FJMessageStore.addMessage(FJLocalStore._('failed-to-upload-please-try-again'), 'error');
                    return;
                }

                //6.检查是否要上传mask 图
                let maskS3Url = undefined;
                if (scratchOrFold) {
                    const maskBlob = await FJViewCanvasSingleton.getMaskImageBlob();
                    maskS3Url = await FJImageStore.uploadFileByBlob(maskBlob);
                }
                if (!_checkIsCurrentTask(currentTaskId)) return;

                const data = {
                    image: imageUrl,
                    colorize: colorize,
                    enhance: enhancerData?.switch,
                    repair: repair,
                    factor,
                    modelType: enhancerData?.imageType,
                    scratch_repair: scratchOrFold,
                    scratch_repair_mask: maskS3Url,
                    original_image: originImageUrl,
                    generate_mask: false,
                };
                //7.创建任务
                f_eventId = await _imageManipulation(data, dispatch);
                dispatch(FJActionCommon.updateFreezeInfoAction());
                const tool = FJUtil.getToolName();
                FJUtil.eaLog('ai tool start generating', { 'credit&free': isFree ? 'free' : 'credit', tool });

                if (!_checkIsCurrentTask(currentTaskId)) return;
                //8.轮询任务状态
                const callback = data => {
                    const { type, waitingEndTime } = data;
                    let _endTime = new Date().getTime();
                    const queuingDuration = FJUtil.getTimeDiff(_startTime, waitingEndTime);
                    const generatingDuration = FJUtil.getTimeDiff(waitingEndTime, _endTime);
                    queuingDuration && (buryData['queuing duration'] = queuingDuration);
                    generatingDuration && (buryData['generating duration'] = generatingDuration);
                    if (type === FJConstant.ERROR) {
                        FJUtil.eaLog('photo restoration & colorizer generate fail', buryData);
                        __errorAndReLoad();
                    } else if (type === FJConstant.SUCCESS) {
                        FJUtil.eaLog('photo restoration & colorizer generate success', buryData);
                        FJUtil.eaLog('ai tool generate success', {
                            tool: FJUtil.getToolName(),
                            'credit&free': isFree ? 'free' : 'credit',
                        });

                        const creationList = getState().common.creationList;
                        dispatch(this.addUseNumFunctionDataAction(options));
                        // 成功后替换编辑区域图片
                        if (creationList.length > 0 && !FJUtil.isMobile()) {
                            const creation = creationList[0];
                            dispatch(FJActionBrushEditCommon.resetMaskAction());
                            dispatch(setSliceDisableCompare(false));
                            dispatch(FJActionBrushEditCommon.updateCompareLineScaleAction(0.3));
                            dispatch(
                                FJActionBrushEditCommon.setEditImageAction({
                                    src: creation.imgUrl,
                                    width: creation.width,
                                    height: creation.height,
                                }),
                            );
                        }
                    }
                };
                dispatch(
                    FJActionCommon.pollingTaskAction([f_eventId], {
                        callback,
                        autoDefaultTaskStatus: !FJUtil.isMobile(),
                    }),
                );
            } catch (e) {
                __errorAndReLoad();
                FJUtil.eaLog('photo restoration & colorizer generate fail', buryData);
            }
        };
    },

    loadImageManipulationPageAction: function () {
        return async dispatch => {
            const recId = FJUtil.getQueryString(FJConstant.REC_ID);
            const recIdInfo = recId ? JSON.parse(window.localStorage.getItem(recId)) : null;
            if (recIdInfo) {
                const url = location.origin + location.pathname;
                FJUtil.changeLocation(url);
                window.localStorage.removeItem(recId);
                const { fileList, avator } = recIdInfo;
                if (fileList) {
                    const fileInfo = fileList[0]?.info;
                    if (!fileInfo) return;
                    const data = await FJLoadLocalforageStore.getItem(fileList[0].key);
                    const file = new File([data.data], fileInfo.name, { type: fileInfo.type });
                    dispatch(FJActionImageManipulation.uploadImageAction(file));
                } else if (avator) {
                    const blob = await FJUtil.getBlobByUrl(avator);
                    dispatch(FJActionImageManipulation.uploadImageAction(blob));
                }
            }
        };
    },

    /**
     * @desc 切换刮擦修复开关
     * @param {boolean} switchScratchOrFold
     * @returns
     */
    setSliceSwitchScratchOrFoldAction: function (switchScratchOrFold) {
        return async (dispatch, getState) => {
            const { curBrushType, isMouseMove } = getState().brushEditCommon;

            if (switchScratchOrFold && curBrushType === MOUSE_EVENT_TYPE.NONE) {
                dispatch(FJActionBrushEditCommon.setCurBrushTypeAction(MOUSE_EVENT_TYPE.MASK_DRAW));
            }

            if (!switchScratchOrFold && curBrushType !== MOUSE_EVENT_TYPE.NONE) {
                dispatch(FJActionBrushEditCommon.setCurBrushTypeAction(MOUSE_EVENT_TYPE.NONE));
            }

            if (!switchScratchOrFold && isMouseMove) {
                dispatch(setSliceIsMouseMove(false));
            }

            dispatch(setSliceSwitchScratchOrFold(switchScratchOrFold));

            if (switchScratchOrFold) {
                await dispatch(this.generateScratchRepairMaskAction());
            } else {
                dispatch(FJActionBrushEditCommon.resetMaskAction());
            }
        };
    },

    /**
     * @desc 下载
     */
    downloadEditImageAction: function () {
        return async dispatch => {
            dispatch(setSliceDownloadEditImageLoading(true));
            const editImageUrl = FJViewCanvasSingleton.getEditImageUrl();
            await FJUtil.multiDownloadByUrls([editImageUrl]);
            dispatch(setSliceDownloadEditImageLoading(false));
        };
    },

    /**
     * @desc 增加使用次数
     * @param {{}} data
     * @returns
     */
    addUseNumFunctionDataAction: function (data) {
        return async (dispatch, getState) => {
            const { repair, colorize, enhancerData, scratchOrFold } = data;

            const useNumFunctionData = getState().imageManipulation.useNumFunctionData;
            dispatch(
                setSliceUseNumFunctionData({
                    oldPhotoRestoration: useNumFunctionData.oldPhotoRestoration + (repair ? 1 : 0),
                    photoColorize: useNumFunctionData.photoColorize + (colorize ? 1 : 0),
                    imageEnhancer: useNumFunctionData.imageEnhancer + (enhancerData?.switch ? 1 : 0),
                    scratchOrFold: useNumFunctionData.scratchOrFold + (scratchOrFold ? 1 : 0),
                }),
            );

            dispatch(this.updateFunctionSwitchAction());
        };
    },

    /**
     * @desc 更具使用次数更新功能开关
     * @param {{}} data
     * @returns
     */
    updateFunctionSwitchAction: function () {
        return (dispatch, getState) => {
            const { imageEnhancerData, useNumFunctionData, switchPhotoColorize } = getState().imageManipulation;

            const { photoColorize, imageEnhancer } = useNumFunctionData;

            dispatch(setSliceSwitchPhotoColorizeAction(photoColorize === 0 && switchPhotoColorize));

            dispatch(
                setSliceImageEnhancerDataAction({
                    ...imageEnhancerData,
                    switch: imageEnhancer === 0 && imageEnhancerData?.switch,
                }),
            );
        };
    },

    /**
     * @desc 重置使用次数
     */
    resetUseNumFunctionDataAction: function () {
        return async dispatch => {
            dispatch(
                setSliceUseNumFunctionData({
                    oldPhotoRestoration: 0,
                    photoColorize: 0,
                    imageEnhancer: 0,
                    scratchOrFold: 0,
                }),
            );
        };
    },

    /**
     * @desc 重置功能开关
     * @returns
     */
    resetSwitchAction: function () {
        return (dispatch, getState) => {
            const { useNumFunctionData } = getState().imageManipulation;

            const { photoColorize, imageEnhancer } = useNumFunctionData;

            photoColorize !== 0 &&
                dispatch(setSliceSwitchPhotoColorizeAction(getState().common.appType === FJAppConstant.PHOTO_COLORIZE));

            imageEnhancer !== 0 &&
                dispatch(
                    setSliceImageEnhancerDataAction({
                        switch: false,
                        imageType: FJConstant.FACE,
                        upscale: 2,
                    }),
                );
        };
    },

    /**
     * @desc 生成mask
     * @returns
     */
    generateScratchRepairMaskAction: function () {
        return async (dispatch, getState) => {
            const appType = getState().common.appType;
            if (
                FJUtil.isLocalhost() ||
                (appType !== FJAppConstant.PHOTO_RESTORATION && appType !== FJAppConstant.PHOTO_COLORIZE)
            )
                return;

            const switchScratchOrFold = getState().imageManipulation.switchScratchOrFold;
            if (!switchScratchOrFold) return;

            const isUploadImage = FJViewCanvasSingleton.getEditImageUrl();
            if (!isUploadImage) return;

            try {
                dispatch(setSliceLoadingModalData({ display: true, message: FJLocalStore._('recognizing...') }));

                const editImageBlob = await FJViewCanvasSingleton.getEditImageBlob();
                if (!editImageBlob) throw new Error('editImageBlob is null');

                // 检查登录
                let isLogin = FJUtil.isLogin();
                if (!isLogin) {
                    dispatch(setSliceLoadingModalData({ display: false }));
                    await new Promise(resolve => {
                        FJUtil.checkIsLogin(
                            () => {
                                isLogin = true;
                                resolve(true);
                            },
                            () => {
                                resolve(false);
                            },
                        );
                    });
                }
                if (!isLogin) throw new Error('isLogin is false');
                dispatch(setSliceLoadingModalData({ display: true, message: FJLocalStore._('recognizing...') }));

                const editImageKey = await FJImageManipulationStore.getKeyByBlob(editImageBlob);
                let maskBlob = await FJImageManipulationStore.getLocalForageItem(editImageKey + '_mask');

                let localMaskUrl = undefined;
                // 如果mask存在，则直接使用
                if (maskBlob) {
                    localMaskUrl = URL.createObjectURL(maskBlob);
                    dispatch(setSliceScratchRepairMaskUrl(localMaskUrl));
                } else {
                    const originImageUrl = await FJImageStore.uploadFileByBlob(editImageBlob);

                    if (!originImageUrl) return;
                    FJImageManipulationStore.setLocalForageItem(editImageKey + '_s3', originImageUrl);

                    const maskUrl = await FJNetworkStore.generateScratchRepairMask({
                        imageUrl: originImageUrl,
                    });

                    const maskBlob = await FJUtil.getBlobByUrl(maskUrl);
                    localMaskUrl = URL.createObjectURL(maskBlob);
                    FJImageManipulationStore.setLocalForageItem(editImageKey + '_mask', maskBlob);
                }

                if (localMaskUrl) {
                    dispatch(setSliceScratchRepairMaskUrl(localMaskUrl));

                    FJViewCanvasSingleton.addUndo();
                    await FJViewCanvasSingleton.drawMaskByImageUrl(localMaskUrl);
                    FJViewCanvasSingleton.draw();
                    dispatch(FJActionBrushEditCommon.updateBrushUndoRedoAction());
                    dispatch(setSliceDisableReset(false));
                }
            } catch (e) {
                FJMessageStore.addMessage(FJLocalStore._('failed-to-recognize'), 'error');
            } finally {
                dispatch(setSliceLoadingModalData({ display: false, message: '' }));
            }
        };
    },

    /**
     * @desc 更新创建编辑数据
     * @returns
     */
    updateCreationEditDataAction: function () {
        return async (dispatch, getState) => {
            dispatch(this.generateScratchRepairMaskAction());

            const uploadImageInfo = getState().imageManipulation.uploadImageInfo;
            await dispatch(FJActionBrushEditCommon.setOriginImageAction(uploadImageInfo));

            dispatch(FJActionBrushEditCommon.updateSlideCompareDataAction());
            dispatch(FJActionBrushEditCommon.updateDisableCompareAction());
        };
    },
};
export default FJActionImageManipulation;
